import {UnitsUtils} from "./units-utils";

export interface WindowDimensionsProps {
    width?: number | string;
    height?: number | string;
    x?: (() => number) | number;
    y?: (() => number) | number;
    aspectRatio?: number; // aspect ratio of the dimension
}

export class WindowDimensions {
    width?: number | string; // original width
    height?: number | string; // original height
    x?: (() => number) | number; // original X position
    y?: (() => number) | number; // original y position
    aspectRatio: number; // aspect ratio of the dimension

    constructor(props?: WindowDimensionsProps) {
        if (props) {
            const aspectRatio = this.calcAspectRatio();
            Object.assign(this, {
                ...props,
                ...{ aspectRatio }
            });
        }
    }

    get dimensions(): WindowDimensionsProps {
        return {
            width: this.width,
            height: this.height,
            x: this.x,
            y: this.y,
            aspectRatio: this.aspectRatio
        };
    }

    set dimensions(props: WindowDimensionsProps) {
        Object.assign(this, props);
        if (!props.aspectRatio) {
            this.aspectRatio = this.calcAspectRatio();
        }
    }

    calcAspectRatio() {
        if (UnitsUtils.isNumeric(this.width) && UnitsUtils.isNumeric(this.height)) {
            // @ts-ignore
            return this.width / this.height;
        } else {
            return 1;
        }
    }
}
